import React from 'react';
import { Table, Tag, Button } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { AuditLogEntry } from '../../../services/auditLogApi';

const ACTION_LABELS: Record<string, string> = {
  create: '新增', update: '修改', delete: '刪除', approve: '核准',
  reject: '退回', void: '作廢', export: '匯出', print: '列印', grant: '授權異動',
};

const ACTION_COLORS: Record<string, string> = {
  create: 'green', update: 'blue', delete: 'red', approve: 'cyan',
  reject: 'orange', void: 'volcano', export: 'purple', print: 'geekblue', grant: 'gold',
};

interface AuditLogTableProps {
  data: AuditLogEntry[];
  loading: boolean;
  total: number;
  page: number;
  pageSize: number;
  onPageChange: (page: number, pageSize: number) => void;
  onViewDetail: (entry: AuditLogEntry) => void;
}

const AuditLogTable: React.FC<AuditLogTableProps> = ({
  data, loading, total, page, pageSize, onPageChange, onViewDetail,
}) => {
  const columns: ColumnsType<AuditLogEntry> = [
    {
      title: '時間', dataIndex: 'occurred_at', key: 'occurred_at', width: 180,
      render: (v: string) => new Date(v).toLocaleString('zh-TW'),
    },
    { title: '使用者', dataIndex: 'user_id', key: 'user_id', width: 140 },
    { title: '表單代碼', dataIndex: 'form_id', key: 'form_id', width: 140 },
    { title: '單號', dataIndex: 'doc_key', key: 'doc_key', width: 160 },
    {
      title: '動作', dataIndex: 'action', key: 'action', width: 100,
      render: (v: string) => <Tag color={ACTION_COLORS[v] || 'default'}>{ACTION_LABELS[v] || v}</Tag>,
    },
    { title: 'IP', dataIndex: 'ip', key: 'ip', width: 130, render: (v: string | null) => v || '-' },
    {
      title: '操作', key: 'detail', width: 100, fixed: 'right',
      render: (_, record) => (
        <Button type="link" onClick={() => onViewDetail(record)}>查看明細</Button>
      ),
    },
  ];

  return (
    <Table<AuditLogEntry>
      rowKey="id"
      columns={columns}
      dataSource={data}
      loading={loading}
      scroll={{ x: 900 }}
      pagination={{
        current: page,
        pageSize,
        total,
        showSizeChanger: true,
        showTotal: (t) => `共 ${t} 筆`,
        onChange: onPageChange,
      }}
    />
  );
};

export default AuditLogTable;
